import React, { FunctionComponent } from 'react';
import { AutomationTemplateContainer } from './AutomationTemplateContainer';

export const ActiveAutomation: FunctionComponent = () => {
  const { activeTemplate } = AutomationTemplateContainer.useContainer();
  if (!activeTemplate) {
    return null;
  }
  const { template } = activeTemplate;
  if (!template.templateBuilder) {
    return null;
  }
  const { maxFollowUpCounts } = template;
  return React.createElement(template.templateBuilder, { maxFollowUpCounts });
};
